/*global define*/
define('core/directives/mboxDirective',[
    'angular',
    'core/services/TrackingService'
], function (angular) {
    'use strict';
    angular.module('dnaApp').directive('mbox', ['$compile', '$q', '$window', 'TrackingService', '$timeout', function ($compile, $q, $window, TrackingService, $timeout) {
        return {
            restrict: 'AE',
            transclude: true,
            scope: {
                params: '=mboxparams',
                services: '=mboxservices',
                variables: '=',
                configsetting: '=',
                loading: '=mboxloading',
                skipmbox: '='
            },
            template: '<div class="dnaMboxTemplate" ng-transclude></div>',
            link: function (scope, element, attributes) {
                function getOffer() {
                    return $q(function (resolve, reject) {
                        var mboxName = attributes.mboxname;
                        var elem = element.find('.dnaMboxTemplate');
                        var options = {
                            mbox: mboxName,
                            params: scope.params,
                            success: function (response) {
                                if (response && response.length > 0 && response[0].action && response[0].action === 'setContent') {
                                    resolve({
                                        mbox: mboxName,
                                        offer: response,
                                        selector: elem[0]
                                    });
                                    $q(function(resolve, reject) {
                                        try {
                                            TrackingService.trackEvent('using mbox');
                                            resolve('');
                                        } catch (e) {
                                            reject(e);
                                        }
                                    });
                                } else {
                                    reject('No offer found');
                                }
                            },
                            error: function (status, error) {
                                reject(error);
                            }
                        };
                        if (!mboxName) {
                            reject('No mboxname attribute found');
                            return false;
                        }
                        $window.adobe.target.getOffer(options);
                    });
                }

                function applyOffer(options) {
                    return $q(function (resolve, reject) {
                        $window.adobe.target.applyOffer(options);
                        $timeout(function () {
                            // transclude has already been done by the directive
                            // Remove the attribute so compiler doesn't fail trying to transclude again
                            // Remove the attribute from all children as they will have already run as well
                            angular.element(options.selector).removeAttr('ng-transclude').find('*').removeAttr('ng-transclude').removeAttr('data-ng-transclude');
                            $compile(options.selector)(scope);
                            scope.loading = false;
                            resolve();
                        }, 100);
                    });
                }

                function startOffer() {
                    element.addClass('mboxDefault');

                    getOffer()
                        .then(applyOffer)
                        .catch(function (error) {
                            $q(function(resolve, reject) {
                                try {
                                    TrackingService.trackEvent('not using mbox');
                                    resolve('');
                                } catch (e) {
                                    reject(e);
                                }
                            });
                            scope.loading = false;
                        })
                        .finally(function () {
                            element.removeClass('mboxDefault');
                        });
                }

                scope.tracking = TrackingService;
                scope.targetEvent = $window.adobe.target.trackEvent;

                if (scope.configsetting && !scope.skipmbox) {
                    scope.loading = true;
                    startOffer();

                    // failsafe if mbox is not returning at all (just in case)
                    // In Reality we would toggle the config flag if there were a problem -which we haven't had. I'm being overly cautious
                    $timeout(function () {
                        scope.loading = false;
                    }, 10000);
                }
            }
        };
    }]);
});

